import React from 'react';

// Actions
import { authorizeEmail, refreshOmniRiskProfile } from '@/redux/modules/omni-risk-profiles';

// Components
import { SendQuestionnaireBody } from './components/SendQuestionnaireBody';
import { withErrorBoundary } from '@/views/components/errors';

// Enums
import { OmniRiskProfileEmailTemplate, OmniRiskProfileStatus } from '@/enums/OmniRiskProfiles';

// Libraries
import { Dispatch } from '@/redux';
import { useDispatch } from 'react-redux';

// Types
import { FormattedFullOmniRiskProfile } from '@/types/risk-profiles/omni/full-omni-risk-profile';

// Utils
import notification from '@/utils/notification';
import { formatMessage } from '@/utils/i18n';

type Props = {
  hasEnforcedContactEmail: boolean;
  initialEmail: string;
  riskProfile: FormattedFullOmniRiskProfile;
};

const SendRefreshQuestionnaire: React.FC<Props> = ({ hasEnforcedContactEmail, initialEmail, riskProfile }) => {
  const dispatch = useDispatch<Dispatch>();
  const { emails = [], status } = riskProfile;
  const sharedEmails = status === OmniRiskProfileStatus.Sent || status === OmniRiskProfileStatus.SentRefresh ? emails : [];

  const handleAuthorizeEmail = async (email: string) => {
    try {
      if (status === OmniRiskProfileStatus.Approved) {
        await dispatch(refreshOmniRiskProfile(riskProfile));
      }
      await dispatch(authorizeEmail(email, riskProfile, OmniRiskProfileEmailTemplate.QuestionnaireInvitation));
      notification.success(
        formatMessage('RiskProfileModal.SendQuestionnaire.AuthorizedNotificationBody'),
        formatMessage('RiskProfileModal.SendQuestionnaire.AuthorizedNotificationTitle'),
      );
    } catch (error) {
      notification.error(formatMessage('RiskProfileModal.SendQuestionnaire.SendEmailError'));
    }
  };

  return (
    <SendQuestionnaireBody
      authorizeEmail={handleAuthorizeEmail}
      className="is-refreshing"
      hasEnforcedContactEmail={hasEnforcedContactEmail}
      initialEmail={initialEmail}
      riskProfile={riskProfile}
      sharedEmails={sharedEmails}
    />
  );
};

export default withErrorBoundary(SendRefreshQuestionnaire);
